import { ElementType } from '@editor2/types/pageElements';

export const DEPRECATED_ELEMENTS = [ElementType.Cosmo, ElementType.GetTheGist];
